import React, { useEffect } from "react";
import "../styles/tour-details.css";
import { Container, Row, Col } from "reactstrap";
import { useParams } from "react-router-dom";
import Booking from "../components/Booking/Booking";
import { BASE_URL, IMAGE_BASE_URL } from "./../utils/config";
import useFetch from "./../hooks/useFetch";

const TourDetails = () => {
  const { id } = useParams();

  const {
    data: tour,
    loading,
    error,
  } = useFetch(`${BASE_URL}/tour/${id}`);

  const { product_image, name, disc, price, main, path, duration, rev } =
    tour;
  const arr = disc?.split(";");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [tour]);

  const renderStars = (rating) => {
    const stars = [];
    for (let i = 0; i < rating; i++) {
      stars.push(
        <i
          key={i}
          className="ri-star-fill"
          style={{ color: "var(--secondary-color)", marginRight: "2px" }}
        ></i>
      );
    }
    return stars;
  };

  return (
    <>
      <section>
        <Container>
          {loading && <h4 className="text-center pt-5">Loading.....</h4>}
          {error && <h4 className="text-center pt-5">{error}</h4>}
          {!loading && !error && (
            <Row>
              <Col lg="8">
                <div className="tour__content">
                  <img
                    src={`${IMAGE_BASE_URL}/${product_image}`}
                    alt=""
                  />

                  <div className="tour__info">
                    <h2>{name}</h2>

                    <div className="d-flex align-items-center gap-5">
                      <div className="tour__rating d-flex align-items-center gap-1">
                        {renderStars(rev)} <span>({rev})</span>
                      </div>

                      <span>
                        <i class="ri-map-pin-user-fill"></i>
                        {main}
                      </span>
                    </div>

                    <div className="tour__extra-details">
                      {/* <span>
                        <i class="ri-map-pin-2-line"></i>
                        {city}
                      </span> */}
                      <span>
                        <i class="ri-money-dollar-circle-line"></i>
                        From {price} Rupees
                      </span>
                      <span>
                        <i class="ri-map-pin-time-line"></i>
                        {duration}
                      </span>

                      <span>
                        <i
                          className="ri-road-map-line"
                          style={{ marginRight: "8px" }}
                        ></i>
                        {path}
                      </span>
                    </div>
                    <h5>Description</h5>
                    {/* <p>{disc}</p> */}
                    <ol
                      style={{ listStyleType: "square" }}
                      className="custom-list"
                    >
                      {arr?.map((item, index) => (
                        <li key={index}>{item}</li>
                      ))}
                    </ol>
                  </div>

                  {/* Tour Reviews Section */}
                  {/* <div className="tour__reviews mt-4">
                    <h4>Reviews ({reviews?.length} reviews)</h4>

                    <Form onSubmit={submitHandler}>
                      <div className="d-flex align-items-center gap-3 mb-4 rating__group">
                        <span onClick={() => setTourRating(1)}>
                          1 <i class="ri-star-s-fill"></i>
                        </span>
                        <span onClick={() => setTourRating(2)}>
                          2 <i class="ri-star-s-fill"></i>
                        </span>
                        <span onClick={() => setTourRating(3)}>
                          3 <i class="ri-star-s-fill"></i>
                        </span>
                        <span onClick={() => setTourRating(4)}>
                          4 <i class="ri-star-s-fill"></i>
                        </span>
                        <span onClick={() => setTourRating(5)}>
                          5 <i class="ri-star-s-fill"></i>
                        </span>
                      </div>

                      <div className="review__input">
                        <input
                          type="text"
                          ref={reviewMsgRef}
                          placeholder="share your thoughts"
                          required
                        />
                        <button
                          className="btn primary__btn text-white"
                          type="submit"
                        >
                          Submit
                        </button>
                      </div>
                    </Form>

                    <ListGroup className="user__reviews">
                      {reviews?.map((review) => (
                        <div className="review__item">
                          <img src={avatar} alt="" />

                          <div className="w-100">
                            <div className="d-flex align-items-center justify-content-between">
                              <div>
                                <h5>{review.username}</h5>
                                <p>
                                  {new Date(
                                    review.createdAt
                                  ).toLocaleDateString("en-US", options)}
                                </p>
                              </div>
                              <span className="d-flex align-items-center">
                                {review.rating}
                                <i class="ri-star-s-fill"></i>
                              </span>
                            </div>
                            <h6>{review.reviewText}</h6>
                          </div>
                        </div>
                      ))}
                    </ListGroup>
                  </div> */}
                </div>
              </Col>

              <Col lg="4">
                <Booking tour={tour} />
              </Col>
            </Row>
          )}
        </Container>
      </section>
      {/* <Newsletter /> */}
    </>
  );
};

export default TourDetails;
